import { ExternalLink, Phone, Mail } from "lucide-react";
import { vendorsApi } from "@/lib/api";
import { EditableItemList } from "./EditableItemList";

const LINK_FIELDS = [
  { key: "title", label: "Titel", required: true, placeholder: "z. B. Admin-Portal" },
  { key: "url", label: "Adresse", required: true, placeholder: "https://…" },
  { key: "description", label: "Kurzbeschreibung", wide: true, multiline: true },
];

const CONTACT_FIELDS = [
  { key: "name", label: "Name", required: true },
  { key: "role", label: "Funktion", placeholder: "z. B. Vertrieb, Support" },
  { key: "phone", label: "Telefonnummer", type: "tel" },
  { key: "email", label: "E-Mail-Adresse", type: "email" },
  { key: "note", label: "Notiz", wide: true, multiline: true },
];

export const openVendorLink = (vendorId, link) => {
  window.open(link.url, "_blank", "noopener,noreferrer");
  vendorsApi.trackClick(vendorId, link.id).catch(() => {});
};

export function VendorLinksTab({ vendor, onItemsChange, isAdmin, canEdit }) {
  return (
    <EditableItemList
      vendorId={vendor.id} kind="links" items={vendor.links || []} fields={LINK_FIELDS} isAdmin={isAdmin} canEdit={canEdit}
      onChanged={(links) => onItemsChange({ links })} addLabel="Link hinzufügen" emptyText="Noch keine Links hinterlegt."
      labels={{ one: "Link" }}
      renderView={(l) => (
        <>
          <a href={l.url} onClick={(e) => { e.preventDefault(); openVendorLink(vendor.id, l); }} className="font-medium text-primary hover:underline inline-flex items-center gap-1.5" data-testid={`vendor-link-open-${l.id}`}>
            {l.title}<ExternalLink className="w-3.5 h-3.5" />
          </a>
          <p className="text-xs text-muted-foreground break-all">{l.url}</p>
          {l.description && <p className="text-sm">{l.description}</p>}
        </>
      )}
    />
  );
}

export const ContactLines = ({ c, testPrefix }) => (
  <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
    {c.phone && <a href={`tel:${c.phone.replace(/[^\d+]/g, "")}`} className="inline-flex items-center gap-1.5 text-primary hover:underline" data-testid={`${testPrefix}-phone`}><Phone className="w-3.5 h-3.5" />{c.phone}</a>}
    {c.email && <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1.5 text-primary hover:underline break-all" data-testid={`${testPrefix}-email`}><Mail className="w-3.5 h-3.5" />{c.email}</a>}
  </div>
);

export function VendorContactsTab({ vendor, onItemsChange, isAdmin, canEdit }) {
  return (
    <EditableItemList
      vendorId={vendor.id} kind="contacts" items={vendor.contacts || []} fields={CONTACT_FIELDS} isAdmin={isAdmin} canEdit={canEdit}
      onChanged={(contacts) => onItemsChange({ contacts })} addLabel="Ansprechpartner hinzufügen" emptyText="Noch keine Ansprechpartner hinterlegt."
      labels={{ one: "Ansprechpartner" }}
      renderView={(c) => (
        <>
          <p className="font-medium">{c.name}{c.role && <span className="text-muted-foreground font-normal"> · {c.role}</span>}</p>
          <ContactLines c={c} testPrefix={`vendor-contact-${c.id}`} />
          {c.note && <p className="text-sm text-muted-foreground whitespace-pre-wrap">{c.note}</p>}
        </>
      )}
    />
  );
}
